"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var selectors_1 = require("../selectors");
var MissedOpportunities_1 = __importDefault(require("./components/MissedOpportunities"));
var ReportMissedOpportunities = function () {
    var lastAudit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    if (!(0, react_redux_firebase_1.isLoaded)(lastAudit)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Saas Audit Missed Opportunities Report", description: "Saas Audit Missed Opportunities Report" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, rowSpacing: 4 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(MissedOpportunities_1.default, { headerLevel: 1, limit: 10, showOthers: true }) })) })) })] }));
};
exports.default = ReportMissedOpportunities;
